'use client';

import { createPortal } from 'react-dom';

/**
 * A safe version of createPortal that works in both client and server environments.
 * Only creates a portal if we're in a browser environment.
 *
 * @param {React.ReactNode} children - The content to render in the portal
 * @param {HTMLElement | null} container - The DOM node to render into
 * @returns {React.ReactPortal | null} The portal or null if not in browser
 */
export function safeCreatePortal(children, container) {
    if (typeof window === 'undefined' || !container) {
        return null;
    }

    return createPortal(children, container);
}

export default safeCreatePortal;
